import { render, staticRenderFns } from "./MenusComanderoForm.vue?vue&type=template&id=18f450d8&scoped=true"
import script from "./MenusComanderoForm.vue?vue&type=script&lang=js"
export * from "./MenusComanderoForm.vue?vue&type=script&lang=js"
import style0 from "./MenusComanderoForm.vue?vue&type=style&index=0&id=18f450d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f450d8",
  null
  
)

export default component.exports